/**
 * @private
 */
export default Object.freeze({
  STOPPED: 0,
  ANIMATING: 1,
});
